import { render, staticRenderFns } from "./ymYou.vue?vue&type=template&id=0fb60946&scoped=true&"
import script from "./ymYou.vue?vue&type=script&lang=js&"
export * from "./ymYou.vue?vue&type=script&lang=js&"
import style0 from "./ymYou.vue?vue&type=style&index=0&id=0fb60946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb60946",
  null
  
)

export default component.exports